import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
export function CtaSection() {
  return <section className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold mb-4">Bereit für Ihre rechtskonforme Karte?</h2>
        <p className="text-xl mb-8 text-muted-foreground max-w-2xl mx-auto">Starten Sie noch heute mit der professionellen Analyse Ihrer Speisen- und Getränkekarte.</p>
        <div className="flex justify-center">
          <Button variant="primary" size="lg" className="px-8 py-4" asChild>
            <Link to="/speisekarte-hochladen">
              Jetzt Hochladen
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}